import React, { Component } from 'react';
import logo from './images/ugov_blue.png';
import bellImg from './images/notifications.png';
import chatImg from './images/chat.png';
import addImg from './images/add.png';
import ProfileWidget from './components/ProfileWidget';
import NotificationMenu from './components/NotificationMenu';
import Profile from './components/Profile';
import Neighbors from './components/Neighbors';
import InviteModal from './components/InviteModal';
import Post from './components/Post';
import Menu from './components/Menu';
import Timeline from './components/Timeline';
import RightColumn from './components/RightColumn';
import ConversationPage from './components/ConversationPage';
import Login from './components/Login';
import SearchResults from './components/SearchResults';
import {getUserInfo} from './Helpers';
import './App.css';

const docTitle = 'UGov Brasil';
const baseUrl = window.location.protocol + '//' + window.location.host;

// if ( window.location.href.indexOf('http:') !== -1) {
  // const locArray = window.location.href.split(':');
  // const newloc = 'https:' + locArray[1];
  // window.location.href = newloc;
// }

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {inviteCode: '', showTimeline: true, showBanner: true};
  }

  hideStuff(e) {
    if (e.target.id === 'mainDiv' || e.target.id === 'anchorDiv' || e.target.id === 'hideStuff') {
      this._profileWidgetRef.setState({showMenu: false});
      this.setState({modal: '', showNotificationMenu: false});
    }
  }

  componentDidMount() {
    getUserInfo(this);
  }

  setCategory(cat) {
    this.setVisible({category: cat, showTimeline: true});
  }

  showNotifications(e) {
    e.preventDefault();
    if (this.state.showNotificationMenu === true) {
      this.setState({showNotificationMenu: false});
    } else {
      this.setState({showNotificationMenu: true});
      if (this._profileWidgetRef) {
        this._profileWidgetRef.setState({showMenu: false});
      }
    }
  }

  setVisible(showHash) {
    if (this._profileWidgetRef) {
      this._profileWidgetRef.setState({showMenu: false});
    }
    let elementHash = {
      showProfile: false,
      showPost: false,
      searching: false,
      showConversations: false,
      showSearchResults: false,
      showTimeline: false,
      showNeighbors: false,
      showNotificationMenu: false,
    };
    let stateHash = Object.assign({}, elementHash, showHash);
    this.setState(stateHash);
  }

  search(e) {
    if (e) e.preventDefault();
    this.setVisible({showSearchResults: true, searching: true});
  }

  showPost(post) {
    this.setVisible({showPost: true, post: post});
  }

  showProfile(user) {
    this.setVisible({profile: user, showProfile: true});
  }

  showNeighbors(e) {
    e.preventDefault();
    this.setVisible({showNeighbors: true});
  }

  showConversations(username=null, conversation=null, conversations=null) {
    let visibleHash = {showConversations: true, showSearchResults: false};
    if (username) {
      visibleHash['neighbor'] = username;
    }
    if (conversation) {
      visibleHash['conversation'] = conversation;
    }
    if (conversations) {
      visibleHash['conversations'] = conversations;
    }
    this.setVisible(visibleHash);
  }

  async addToConversation(conversation, username) {
    let conv = conversation || this.state.conversation;
    let convId = conv._id.$oid;
    let users = conv['users'].map(x => x.username), that = this;
    if (!users.includes(username)) {
      users.push(username);
    }
    let params = new FormData();
    for (let i = 0; i < users.length; i++) {
      params.append('conversation[neighbors][]', users[i]);
    }
    let updateParams = {
      uri: `/api/v1/conversations/${convId}`,
      method: 'PUT',
      body: params
    };
    const d = await fetch(updateParams.uri, updateParams);
    d.json().then(data => {
      let convo = data.conversation;
      let newConversations = that.state.conversations.filter(conv => conv._id.$oid !== convo['_id']['$oid']);
      newConversations.push(convo);
      that.setState({conversation: convo, conversations: newConversations});
    });
  }

  showInviteModal(event) {
    // TODO - Get rid of this hackery at some point.
    this.setState({modal: <InviteModal app={this} user={this.state.user} />});
  }

  hideBanner(e) {
    e.preventDefault();
    this.setState({showBanner: false});
  }

  acceptOrgRequest() {
    try {
      fetch(window.location.href, function(err, data)  {
        if (data) {
          console.log('Accepted request to join org.');
        } else {
          console.log('Got nothing: err is: ' + err);
        }
      });
    } catch(e) {
      console.log('Accept org request unsuccessful.');
    }
  }

  render() {
    let docNotfCounter = 0;
    if (this.state.notificationCounter) {
      docNotfCounter = this.state.notificationCounter;
    }
    if (this.state.messageCounter) {
      docNotfCounter += this.state.messageCounter;
    }
    if (docNotfCounter) {
      document.title = `${docTitle} (${docNotfCounter})`;
    } else {
      document.title = docTitle;
    }
    let messageCount = '';
    if (this.state && this.state.messageCounter) {
      messageCount = <div className='messageCounter'>{this.state.messageCounter}</div>;
    }
    let notificationCount = '';
    if (this.state && this.state.notificationCounter) {
      notificationCount = <div className='notificationCounter'>{this.state.notificationCounter}</div>;
    }
    let that = this;
    let logoSrc = logo;
    if (window.location.host.indexOf('.ugov.co') !== -1) {
      logoSrc = '/static/media/logo_' + window.location.host.split('.').shift() + '.png';
    }
    let bannerMessage = '';
    let banner = undefined;
    if (window.location.href.indexOf('accepted_user') !== -1) {
      bannerMessage = window.location.href.split('=').pop() + ' fui adicionado para seo organizacao';
    }
    if (bannerMessage !== '' && this.state.showBanner) {
      banner = <div className='mainBanner' id='banner'><div className='closeModalButton' onClick={(e) => this.hideBanner(e)}>x</div>{bannerMessage}</div>;
    }
    if (window.location.href.indexOf('api/v1/invites') !== -1 && window.location.href.indexOf('/accept') !== -1) {
      // Sloppy, but works for now. Make the call to accept this invite.
      this.acceptOrgRequest();
    }
    if (this.state?.user) {
      let headerClass = 'titlediv';
      if (this.state.user.org_mode) {
        headerClass = 'titledivGreen';
      }
      return(
        <div id='anchorDiv' onClick={(e) => this.hideStuff(e)} className='anchor'>
          {this.state.modal || ''}
          <div className={headerClass}>
             <div className="logodiv">
               <img className='logo' onClick={(e) => this.setCategory(undefined)} src={logoSrc} alt="" />
               <form onSubmit={(e) => this.search(e)}><input className='searchInput' placeholder='Procurar' type='text'
                     onChange={(e) => this.setState({searchString: e.target.value})} value={this.state.searchString || ''} /></form>
               {banner}
               <div>
                 <img className='headerIcon bellHeader' onClick={(e) => this.showNotifications(e)} src={bellImg} alt="Notiçias" />
                 {notificationCount}
               </div>
               <div>
                 <img className='headerIcon chatHeader' onClick={() => this.showConversations()} src={chatImg} alt="Conversas" />
                 {messageCount}
               </div>
               <img className='headerIcon addHeader' onClick={(e) => this.showInviteModal(e)} src={addImg} alt="Adicionar" />
               <ProfileWidget ref={(ref) => this._profileWidgetRef = ref} app={this} user={this.state.user} username={this.state.user.username}
                              avatar={this.state.user.avatar} />
               <NotificationMenu onScroll={(e) => that.handleScroll(e)} app={this} user={this.state.user} ref={(ref) => this._notificationMenu = ref}
                                 style={{display: this.state.showNotificationMenu ? 'inline-block' : 'none'}} />
             </div>
          </div>

          <div className='main' id='mainDiv' onClick={(e) => this.hideStuff(e)}>
            { this.state.showConversations ?
            <ConversationPage user={this.state.user} area={this.state.area} conversation={this.state.conversation} conversations={this.state.conversations || []}
                              ref={(ref) => this._conversationPage = ref}
                              app={this} neighbor={this.state.neighbor} /> : <Menu app={this} area={this.state.area} />}

            {/* CENTER COLUMN */}
            <div className='timeline' style={{display: this.state.showPost ? 'inline-block' : 'none'}}>
              <div className='timelineInner'>
                {this.state.showPost ? <Post user={this.state.post.user} app={this} data={this.state.post} current_user={this.state.user} /> : ''}
              </div>
            </div>
            {this.state.showSearchResults ? <SearchResults query={this.state.searchString} searchType={this.state.searchType} user={this.state.user} searching={this.state.searching} app={this} area={this.state.area} /> : ''}
            {this.state.showNeighbors ? <Neighbors key='neighbors' app={this} area={this.state.area} /> : ''}
            {this.state.showProfile ? <Profile app={this} user={this.state.profile} currentUser={this.state.user} /> : ''}
            {this.state.showTimeline ? <Timeline category={this.state.category} key='timeline' app={this} user={this.state.user} /> : ''}
            {/* END CENTER COLUMN */}

            <RightColumn area={this.state.area} lat={this.state.user.location[1]} lon={this.state.user.location[0]} app={this} />
          </div>
        </div>
      );
    } else if (this.state?.login) {
      return (<Login mainApp={this} />);
    } else {
      return null;
    }
  }
}

export default App;
